import { NgModule } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { OauthService } from '@monsido/oauth/oauth.service';

@NgModule({ exports: [],
    declarations: [], imports: [], providers: [OauthService, provideHttpClient(withInterceptorsFromDi())] })
export class OauthModule {}
